/**
 * LD.CLPBP.Public.Service
 * No descripton provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {Http, Headers, RequestOptionsArgs, Response, URLSearchParams} from '@angular/http';
import {Injectable, Optional} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import * as models from '../model/models';
import 'rxjs/Rx';

/* tslint:disable:no-unused-variable member-ordering */

'use strict';

@Injectable()
export class BorrowerApi {
    protected basePath = 'http://localhost:2586';
    public defaultHeaders : Headers = new Headers();

    constructor(protected http: Http, @Optional() basePath: string) {
        if (basePath) {
            this.basePath = basePath;
        }
    }

    /**
     * Gets the borrower for a given Id
     * 
     * @param borrowerId 
     * @param authorization Authorization Header. Substitute value of Token parameter with the desired token.
     */
    public borrowerBorrowerGetMortgageBorrower (borrowerId: string, authorization: string, extraHttpRequestParams?: any ) : Observable<models.LDCLPBPPublicApiModelsBorrowersMortgageBorrower> {
        const path = this.basePath + '/api/v1/borrowers/borrower/{borrowerId}'
            .replace('{' + 'borrowerId' + '}', String(borrowerId));

        let queryParameters = new URLSearchParams();
        let headerParams = this.defaultHeaders;
        // verify required parameter 'borrowerId' is not null or undefined
        if (borrowerId === null || borrowerId === undefined) {
            throw new Error('Required parameter borrowerId was null or undefined when calling borrowerBorrowerGetMortgageBorrower.');
        }
        // verify required parameter 'authorization' is not null or undefined
        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling borrowerBorrowerGetMortgageBorrower.');
        }
            headerParams.set('Authorization', String(authorization));

        let requestOptions: RequestOptionsArgs = {
            method: 'GET',
            headers: headerParams,
            search: queryParameters
        };

        return this.http.request(path, requestOptions)
            .map((response: Response) => {
                if (response.status === 204) {
                    return undefined;
                } else {
                    return response.json();
                }
            });
    }

    /**
     * 
     * 
     * @param borrowerWebGuid 
     * @param authorization Authorization Header. Substitute value of Token parameter with the desired token.
     */
    public borrowerBorrowerGetMortgageBorrowerByWebGuid (borrowerWebGuid: string, authorization: string, extraHttpRequestParams?: any ) : Observable<{}> {
        const path = this.basePath + '/api/v1/borrowers/borrower/webID/{borrowerWebGuid}'
            .replace('{' + 'borrowerWebGuid' + '}', String(borrowerWebGuid));

        let queryParameters = new URLSearchParams();
        let headerParams = this.defaultHeaders;
        // verify required parameter 'borrowerWebGuid' is not null or undefined
        if (borrowerWebGuid === null || borrowerWebGuid === undefined) {
            throw new Error('Required parameter borrowerWebGuid was null or undefined when calling borrowerBorrowerGetMortgageBorrowerByWebGuid.');
        }
        // verify required parameter 'authorization' is not null or undefined
        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling borrowerBorrowerGetMortgageBorrowerByWebGuid.');
        }
            headerParams.set('Authorization', String(authorization));

        let requestOptions: RequestOptionsArgs = {
            method: 'GET',
            headers: headerParams,
            search: queryParameters
        };

        return this.http.request(path, requestOptions)
            .map((response: Response) => {
                if (response.status === 204) {
                    return undefined;
                } else {
                    return response.json();
                }
            });
    }

    /**
     * Determine if a borrower email address is available
     * 
     * @param emailAddress 
     * @param authorization Authorization Header. Substitute value of Token parameter with the desired token.
     */
    public borrowerEmailAvailability (emailAddress: string, authorization: string, extraHttpRequestParams?: any ) : Observable<models.LDCommonWebApiResponseApiResponseLDCLPBPPublicApiModelsBorrowersEmailAvailabilityResponse> {
        const path = this.basePath + '/api/v1/borrowers/emails/availability';

        let queryParameters = new URLSearchParams();
        let headerParams = this.defaultHeaders;
        // verify required parameter 'emailAddress' is not null or undefined
        if (emailAddress === null || emailAddress === undefined) {
            throw new Error('Required parameter emailAddress was null or undefined when calling borrowerEmailAvailability.');
        }
        // verify required parameter 'authorization' is not null or undefined
        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling borrowerEmailAvailability.');
        }
        if (emailAddress !== undefined) {
            queryParameters.set('emailAddress', String(emailAddress));
        }

            headerParams.set('Authorization', String(authorization));

        let requestOptions: RequestOptionsArgs = {
            method: 'GET',
            headers: headerParams,
            search: queryParameters
        };

        return this.http.request(path, requestOptions)
            .map((response: Response) => {
                if (response.status === 204) {
                    return undefined;
                } else {
                    return response.json();
                }
            });
    }

    /**
     * Gets loans for borrower user
     * 
     * @param authorization Authorization Header. Substitute value of Token parameter with the desired token.
     */
    public borrowerGetAssociation (authorization: string, extraHttpRequestParams?: any ) : Observable<models.LDCommonWebApiResponseApiResponseSystemCollectionsGenericListLDCLPBPPublicApiModelsBorrowersBorrowerAssociation> {
        const path = this.basePath + '/api/v1/borrowers/loan/associations';

        let queryParameters = new URLSearchParams();
        let headerParams = this.defaultHeaders;
        // verify required parameter 'authorization' is not null or undefined
        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling borrowerGetAssociation.');
        }
            headerParams.set('Authorization', String(authorization));

        let requestOptions: RequestOptionsArgs = {
            method: 'GET',
            headers: headerParams,
            search: queryParameters
        };

        return this.http.request(path, requestOptions)
            .map((response: Response) => {
                if (response.status === 204) {
                    return undefined;
                } else {
                    return response.json();
                }
            });
    }

    /**
     * Retrieve a borrower
     * 
     * @param borrowerGuid 
     * @param authorization Authorization Header. Substitute value of Token parameter with the desired token.
     */
    public borrowerGetBorrower (borrowerGuid: string, authorization: string, extraHttpRequestParams?: any ) : Observable<models.LDCommonWebApiResponseApiResponseLDCLPBPPublicApiModelsBorrowersGetBorrowerResponse> {
        const path = this.basePath + '/api/v1/borrowers/{borrowerGuid}'
            .replace('{' + 'borrowerGuid' + '}', String(borrowerGuid));

        let queryParameters = new URLSearchParams();
        let headerParams = this.defaultHeaders;
        // verify required parameter 'borrowerGuid' is not null or undefined
        if (borrowerGuid === null || borrowerGuid === undefined) {
            throw new Error('Required parameter borrowerGuid was null or undefined when calling borrowerGetBorrower.');
        }
        // verify required parameter 'authorization' is not null or undefined
        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling borrowerGetBorrower.');
        }
            headerParams.set('Authorization', String(authorization));

        let requestOptions: RequestOptionsArgs = {
            method: 'GET',
            headers: headerParams,
            search: queryParameters
        };

        return this.http.request(path, requestOptions)
            .map((response: Response) => {
                if (response.status === 204) {
                    return undefined;
                } else {
                    return response.json();
                }
            });
    }

    /**
     * 
     * 
     * @param borrowerGuid 
     * @param loanGuid 
     * @param authorization Authorization Header. Substitute value of Token parameter with the desired token.
     */
    public borrowerGetBorrowerLoanApplicationsStates (borrowerGuid: string, loanGuid: string, authorization: string, extraHttpRequestParams?: any ) : Observable<models.LDCommonWebApiResponseApiResponseLDCLPBPPublicApiModelsBorrowersGetBorrowerLoanApplicationsStatesResponse> {
        const path = this.basePath + '/api/v1/borrowers/{borrowerGuid}/state/{loanGuid}'
            .replace('{' + 'borrowerGuid' + '}', String(borrowerGuid))
            .replace('{' + 'loanGuid' + '}', String(loanGuid));

        let queryParameters = new URLSearchParams();
        let headerParams = this.defaultHeaders;
        // verify required parameter 'borrowerGuid' is not null or undefined
        if (borrowerGuid === null || borrowerGuid === undefined) {
            throw new Error('Required parameter borrowerGuid was null or undefined when calling borrowerGetBorrowerLoanApplicationsStates.');
        }
        // verify required parameter 'loanGuid' is not null or undefined
        if (loanGuid === null || loanGuid === undefined) {
            throw new Error('Required parameter loanGuid was null or undefined when calling borrowerGetBorrowerLoanApplicationsStates.');
        }
        // verify required parameter 'authorization' is not null or undefined
        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling borrowerGetBorrowerLoanApplicationsStates.');
        }
            headerParams.set('Authorization', String(authorization));

        let requestOptions: RequestOptionsArgs = {
            method: 'GET',
            headers: headerParams,
            search: queryParameters
        };

        return this.http.request(path, requestOptions)
            .map((response: Response) => {
                if (response.status === 204) {
                    return undefined;
                } else {
                    return response.json();
                }
            });
    }

    /**
     * Create a new borrower
     * 
     * @param request 
     * @param authorization Authorization Header. Substitute value of Token parameter with the desired token.
     */
    public borrowerRegisterBorrower (request: models.LDCLPBPPublicApiModelsBorrowersRegisterBorrowerRequest, authorization: string, extraHttpRequestParams?: any ) : Observable<models.LDCommonWebApiResponseApiResponseLDCLPBPPublicApiModelsBorrowersRegisterBorrowerResponse> {
        const path = this.basePath + '/api/v1/borrowers';

        let queryParameters = new URLSearchParams();
        let headerParams = this.defaultHeaders;
        // verify required parameter 'request' is not null or undefined
        if (request === null || request === undefined) {
            throw new Error('Required parameter request was null or undefined when calling borrowerRegisterBorrower.');
        }
        // verify required parameter 'authorization' is not null or undefined
        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling borrowerRegisterBorrower.');
        }
            headerParams.set('Authorization', String(authorization));

        let requestOptions: RequestOptionsArgs = {
            method: 'POST',
            headers: headerParams,
            search: queryParameters
        };
        requestOptions.body = JSON.stringify(request);

        return this.http.request(path, requestOptions)
            .map((response: Response) => {
                if (response.status === 204) {
                    return undefined;
                } else {
                    return response.json();
                }
            });
    }

    /**
     * Register a new borrower for a personal loan
     * 
     * @param request 
     * @param authorization Authorization Header. Substitute value of Token parameter with the desired token.
     */
    public borrowerRegisterForPersonalLoan (request: models.LDCLPBPPublicApiModelsBorrowersRegisterForPersonalLoanRequest, authorization: string, extraHttpRequestParams?: any ) : Observable<models.LDCommonWebApiResponseApiResponseLDCLPBPPublicApiModelsBorrowersRegisterForPersonalLoanResponse> {
        const path = this.basePath + '/api/v1/borrowers/registration/personal';

        let queryParameters = new URLSearchParams();
        let headerParams = this.defaultHeaders;
        // verify required parameter 'request' is not null or undefined
        if (request === null || request === undefined) {
            throw new Error('Required parameter request was null or undefined when calling borrowerRegisterForPersonalLoan.');
        }
        // verify required parameter 'authorization' is not null or undefined
        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling borrowerRegisterForPersonalLoan.');
        }
            headerParams.set('Authorization', String(authorization));

        let requestOptions: RequestOptionsArgs = {
            method: 'POST',
            headers: headerParams,
            search: queryParameters
        };
        requestOptions.body = JSON.stringify(request);

        return this.http.request(path, requestOptions)
            .map((response: Response) => {
                if (response.status === 204) {
                    return undefined;
                } else {
                    return response.json();
                }
            });
    }

    /**
     * Create a new mortgage
     * 
     * @param request Mortgage request
     * @param authorization Authorization Header. Substitute value of Token parameter with the desired token.
     */
    public borrowerRegisterMortgage (request: models.LDCLPBPPublicApiModelsBorrowersRegisterForMortgageRequest, authorization: string, extraHttpRequestParams?: any ) : Observable<models.LDCommonWebApiResponseApiResponseLDCLPBPPublicApiModelsBorrowersRegisterForMortgageResponse> {
        const path = this.basePath + '/api/v1/borrowers/registration/mortgage';

        let queryParameters = new URLSearchParams();
        let headerParams = this.defaultHeaders;
        // verify required parameter 'request' is not null or undefined
        if (request === null || request === undefined) {
            throw new Error('Required parameter request was null or undefined when calling borrowerRegisterMortgage.');
        }
        // verify required parameter 'authorization' is not null or undefined
        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling borrowerRegisterMortgage.');
        }
            headerParams.set('Authorization', String(authorization));

        let requestOptions: RequestOptionsArgs = {
            method: 'POST',
            headers: headerParams,
            search: queryParameters
        };
        requestOptions.body = JSON.stringify(request);

        return this.http.request(path, requestOptions)
            .map((response: Response) => {
                if (response.status === 204) {
                    return undefined;
                } else {
                    return response.json();
                }
            });
    }

    /**
     * Create a new mortgage borrower
     * 
     * @param request 
     * @param authorization Authorization Header. Substitute value of Token parameter with the desired token.
     */
    public borrowerRegisterMortgageBorrower (request: models.LDCLPBPPublicApiModelsBorrowersRegisterMortgageBorrowerRequest, authorization: string, extraHttpRequestParams?: any ) : Observable<models.LDCommonWebApiResponseApiResponseLDCLPBPPublicApiModelsBorrowersRegisterMortgageBorrowerResponse> {
        const path = this.basePath + '/api/v1/borrowers/create/mortgage';

        let queryParameters = new URLSearchParams();
        let headerParams = this.defaultHeaders;
        // verify required parameter 'request' is not null or undefined
        if (request === null || request === undefined) {
            throw new Error('Required parameter request was null or undefined when calling borrowerRegisterMortgageBorrower.');
        }
        // verify required parameter 'authorization' is not null or undefined
        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling borrowerRegisterMortgageBorrower.');
        }
            headerParams.set('Authorization', String(authorization));

        let requestOptions: RequestOptionsArgs = {
            method: 'POST',
            headers: headerParams,
            search: queryParameters
        };
        requestOptions.body = JSON.stringify(request);

        return this.http.request(path, requestOptions)
            .map((response: Response) => {
                if (response.status === 204) {
                    return undefined;
                } else {
                    return response.json();
                }
            });
    }

    /**
     * Patch an existing borrower
     * 
     * @param borrowerGuid 
     * @param request 
     * @param authorization Authorization Header. Substitute value of Token parameter with the desired token.
     */
    public borrowerUpdateBorrower (borrowerGuid: string, request: models.LDCLPBPPublicApiModelsBorrowersUpdateBorrowerRequest, authorization: string, extraHttpRequestParams?: any ) : Observable<any> {
        const path = this.basePath + '/api/v1/borrowers/{borrowerGuid}'
            .replace('{' + 'borrowerGuid' + '}', String(borrowerGuid));

        let queryParameters = new URLSearchParams();
        let headerParams = this.defaultHeaders;
        // verify required parameter 'borrowerGuid' is not null or undefined
        if (borrowerGuid === null || borrowerGuid === undefined) {
            throw new Error('Required parameter borrowerGuid was null or undefined when calling borrowerUpdateBorrower.');
        }
        // verify required parameter 'request' is not null or undefined
        if (request === null || request === undefined) {
            throw new Error('Required parameter request was null or undefined when calling borrowerUpdateBorrower.');
        }
        // verify required parameter 'authorization' is not null or undefined
        if (authorization === null || authorization === undefined) {
            throw new Error('Required parameter authorization was null or undefined when calling borrowerUpdateBorrower.');
        }
            headerParams.set('Authorization', String(authorization));

        let requestOptions: RequestOptionsArgs = {
            method: 'PATCH',
            headers: headerParams,
            search: queryParameters
        };
        requestOptions.body = JSON.stringify(request);

        return this.http.request(path, requestOptions)
            .map((response: Response) => {
                if (response.status === 204) {
                    return undefined;
                } else {
                    return response.json();
                }
            });
    }

}
